var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 17.5,
    stroke: "#DA1467"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9165 31.6667C17.5832 31.6667 17.2915 31.5417 17.0415 31.2917C16.7915 31.0417 16.6665 30.75 16.6665 30.4167V19.5834C16.6665 19.25 16.7915 18.9584 17.0415 18.7084C17.2915 18.4584 17.5832 18.3334 17.9165 18.3334H32.0832C32.4165 18.3334 32.7082 18.4584 32.9582 18.7084C33.2082 18.9584 33.3332 19.25 33.3332 19.5834V30.4167C33.3332 30.75 33.2082 31.0417 32.9582 31.2917C32.7082 31.5417 32.4165 31.6667 32.0832 31.6667H17.9165ZM24.9998 25.375L17.9165 20.7292V30.4167H32.0832V20.7292L24.9998 25.375ZM24.9998 24.125L31.9998 19.5834H18.0207L24.9998 24.125ZM17.9165 20.7292V19.5834V20.7292V30.4167V20.7292Z",
    fill: "#DA1467"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.919efae2.svg";
export { ForwardRef as ReactComponent };